import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default26wkpamqcsrjk as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      x25(_this__u8e3s4, index) {
        return this.z25(this.y25(_this__u8e3s4, index));
      }
      z25(nestedName) {
        var tmp0_elvis_lhs = this.c26();
        return this.d26(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      y25(descriptor, index) {
        return descriptor.x1p(index);
      }
      d26(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      e26() {
        return this.a26_1.s1() ? '$' : joinToString(this.a26_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.s26(tag);
  var r = block();
  if (!$this.b26_1) {
    $this.t26();
  }
  $this.b26_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.a26_1 = ArrayList().u2();
        this.b26_1 = false;
      }
      d1s() {
        return EmptySerializersModule();
      }
      f26(tag) {
        throw SerializationException().s1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      g26(tag) {
        return true;
      }
      h26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      i26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      j26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      k26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      l26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      m26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      n26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      o26(tag) {
        var tmp = this.f26(tag);
        return tmp instanceof Char() ? tmp.j4_1 : THROW_CCE();
      }
      p26(tag) {
        var tmp = this.f26(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      q26(tag, enumDescriptor) {
        var tmp = this.f26(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      r26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.s26(tag);
        return this;
      }
      m1r(deserializer, previousValue) {
        return this.n1r(deserializer);
      }
      l1r(descriptor) {
        return this.r26(this.t26(), descriptor);
      }
      z1q() {
        var tmp0_elvis_lhs = this.c26();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.g26(currentTag);
      }
      a1r() {
        return null;
      }
      b1r() {
        return this.h26(this.t26());
      }
      c1r() {
        return this.i26(this.t26());
      }
      d1r() {
        return this.j26(this.t26());
      }
      e1r() {
        return this.k26(this.t26());
      }
      f1r() {
        return this.l26(this.t26());
      }
      g1r() {
        return this.m26(this.t26());
      }
      h1r() {
        return this.n26(this.t26());
      }
      i1r() {
        return this.o26(this.t26());
      }
      j1r() {
        return this.p26(this.t26());
      }
      k1r(enumDescriptor) {
        return this.q26(this.t26(), enumDescriptor);
      }
      o1r(descriptor) {
        return this;
      }
      p1r(descriptor) {
      }
      q1r(descriptor, index) {
        return this.h26(this.x25(descriptor, index));
      }
      r1r(descriptor, index) {
        return this.i26(this.x25(descriptor, index));
      }
      s1r(descriptor, index) {
        return this.j26(this.x25(descriptor, index));
      }
      t1r(descriptor, index) {
        return this.k26(this.x25(descriptor, index));
      }
      u1r(descriptor, index) {
        return this.l26(this.x25(descriptor, index));
      }
      v1r(descriptor, index) {
        return this.m26(this.x25(descriptor, index));
      }
      w1r(descriptor, index) {
        return this.n26(this.x25(descriptor, index));
      }
      x1r(descriptor, index) {
        return this.o26(this.x25(descriptor, index));
      }
      y1r(descriptor, index) {
        return this.p26(this.x25(descriptor, index));
      }
      z1r(descriptor, index) {
        return this.r26(this.x25(descriptor, index), descriptor.a1q(index));
      }
      a1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.x25(descriptor, index);
        return tagBlock(this, tmp, () => this.m1r(deserializer, previousValue));
      }
      c1s(descriptor, index, deserializer, previousValue) {
        var tmp = this.x25(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.x1m().m1p();
          var tmp;
          if (isNullabilitySupported || this.z1q()) {
            tmp = this.m1r(deserializer, previousValue);
          } else {
            tmp = this.a1r();
          }
          return tmp;
        });
      }
      c26() {
        return lastOrNull(this.a26_1);
      }
      s26(name) {
        this.a26_1.n2(name);
      }
      t26() {
        var r = this.a26_1.h5(get_lastIndex(this.a26_1));
        this.b26_1 = true;
        return r;
      }
    }
    protoOf($).b1s = decodeSerializableElement$default;
    protoOf($).n1r = decodeSerializableValue;
    protoOf($).e1s = decodeSequentially;
    protoOf($).g1s = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
